import { differenceInCalendarDays } from 'date-fns';
import { dateFromString } from 'lib/date';

export const getNumNights = (checkIn, checkOut) => differenceInCalendarDays(dateFromString(checkOut), dateFromString(checkIn));
